import { render, staticRenderFns } from "./NewMitraReport.vue?vue&type=template&id=6d53f3c8&"
import script from "./NewMitraReport.vue?vue&type=script&lang=js&"
export * from "./NewMitraReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports